<template>
    <span>
        <v-btn icon class="mx-0" @click="deletecat()">
                      <v-icon color="red">delete</v-icon>
          </v-btn>
        </span>
</template>

<script>
import {deleteModuleWithAttachment,deleteCorrespend,getLinkedCat} from '@/model';
import moment from 'moment';
export default {
    name: 'DeleteCategory',
    props:{
        name :{
            required:true
        }
    },
    data() {
        return {
           
         
        };
    },
    methods: {
        deletecat() {
            let self=this;
            let confirmed =  confirm('Warning!!! \n This will delete all movies in this category, do you continue?','Exodus','Yes','No');
    
            if(confirmed){
            
            let datenow = moment().format('DD/MM/YYYY');
            console.log(datenow);
            
            getLinkedCat('campus','category',self.name,function(res){
                if(res.value==true){
                    alert("Please you can't edit nor delete a category after it has been linked to a campus.\n First unlink the movie from all campuses it is attached to.");
            }else{
                    deleteModuleWithAttachment('category',self.name,function(response){
              if(response){
                    console.log("This is response: ",response);
                    deleteCorrespend('movie',self.name,'category',function(res){
                    if(res){
                                           
                    self.$store.dispatch('updateCategory',true);
                    alert('This has been successfully deleted');
                   
                    console.log(res);
                   
                        }
                    });
                  
                  }else{
                      alert('An error occured,please try again','Exodus');
                  }

              });
                }
            })
            

                          }
        }
    }
};
</script>

<style scoped>
</style>